export const en_lang_keys = {
  site_title: 'Interaction 21 • 31 January to 5 February 2021',
  meta_description:
    'In 2021, Interaction week will be a virtual one for the first time, bearing the theme: Design in perilous times',
  nav_menu: 'MENU',
  nav_tickets_avail_soon: 'Tickets available soon',
  nav_get_tickets: 'Get tickets',
  nav_close: 'CLOSE',
  nav_color_mode: 'Mode',
  nav_dark: 'Dark',
  nav_light: 'Light',
  about_heading: 'About',
  about_team_h2: 'The Interaction 21 team',
  about_team_text:
    'Interaction 21 is possible thanks to the dedication of these passionate individuals.',
  get_involved_heading: 'Get involved',
  faq_heading: 'FAQ',
  cfp_title: 'Call for proposals',
  coc_title: 'Code of conduct',
  privacy_title: 'Privacy policy',
  accessibility_title: 'Accessibility',
  footer_join_the_conversation: 'Get in touch',
  footer_get_involved: 'Get involved',
  footer_follow_the_movement: 'Follow the movement',
  footer_sub_to_our_newsletter: 'Subscribe to our newsletter',
  footer_enter_your_email: 'Enter your email',
  footer_subscribe_btn: 'Subscribe',
  footer_coc: 'Code of conduct',
  footer_privacy: 'Privacy',
  footer_copyright: 'Copyright Interaction Design Association',
  footer_accessibility: 'Accessibility',
};
